import { kodplaner_ekkodplaner } from '../../../Components/KodplanManager/Queries/_QueryTypes/kodplaner';
import { AvenyCollectionMap, IAvenyModelContext } from '../ModelContext';
import {
  IClientBusinessModel,
  IClientAttributeModel,
  IClientAssociationModel,
} from '../../../Types/ClientModelTypes';
import { map } from 'ramda';
import { updateAttribute } from './UpdateAttributeUtils';
import { updateAssociation } from './UpdateAssociationUtils';
import type { ISessionInfo } from '../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';

const updateCollection =
  (kodplan: kodplaner_ekkodplaner, sessionInfo: ISessionInfo | undefined) =>
  (
    collectionEntry: [string, IClientBusinessModel]
  ): [string, IClientBusinessModel] => {
    const [collectionName, collection] = collectionEntry;

    const newAttributes: { [key: string]: IClientAttributeModel } = map(
      updateAttribute(collectionName ?? '', kodplan, sessionInfo),
      collection.Attributes
    );
    const newAssociations: { [key: string]: IClientAssociationModel } = map(
      updateAssociation(kodplan, sessionInfo),
      collection.Associations
    );

    const newCollection: IClientBusinessModel = {
      ...collection,
      Attributes: newAttributes,
      Associations: newAssociations,
    };

    return [collectionName, newCollection];
  };

export const updateModelContext = (
  kodplan: kodplaner_ekkodplaner | undefined,
  sessionInfo: ISessionInfo | undefined,
  model: AvenyCollectionMap
): IAvenyModelContext => {
  if (kodplan) {
    return {
      avenyCollectionMap: new Map(
        Array.from(model.entries()).map(updateCollection(kodplan, sessionInfo))
      ),
    };
  } else {
    return { avenyCollectionMap: model };
  }
};
